import { render, staticRenderFns } from "./ArticleDetails.vue?vue&type=template&id=7453e470&scoped=true&"
import script from "./ArticleDetails.vue?vue&type=script&lang=js&"
export * from "./ArticleDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetails.vue?vue&type=style&index=0&id=7453e470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7453e470",
  null
  
)

export default component.exports